import { createContext } from 'react';
export var ModalContext = /*#__PURE__*/createContext({});
//# sourceMappingURL=contexts.js.map